import { useQuery } from '@tanstack/react-query';
import { features } from '@ui/components/Features';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { getLpAmountStaked } from '@ui/queries/sdk';
import type { GardenType } from '@ui/utils/garden';
import { currentWallet } from '@veno-app/wallet';

import { useCoinMode } from './useCoinMode';
import { isFeatureEnabled } from './useIsFeatureEnabled';

const { useAccount } = currentWallet;

const useLpAmountsStaked = (type?: GardenType) => {
  const coinMode = useCoinMode();
  const tectonicEnabled = isFeatureEnabled(features.TectonicGarden);
  const sdk = useVenoSDK();
  const account = useAccount();
  const tectonicQuery = getLpAmountStaked(
    coinMode,
    sdk,
    account ?? '',
    'TECTONIC',
  );
  const ferroQuery = getLpAmountStaked(coinMode, sdk, account ?? '', 'FERRO');
  const vvsQuery = getLpAmountStaked(coinMode, sdk, account ?? '', 'VVS');
  const vvsCroQuery = getLpAmountStaked(
    coinMode,
    sdk,
    account ?? '',
    'VVS_CRO',
  );

  const { data: stakedTectonic, isLoading: tectonicLoading } = useQuery(
    tectonicQuery.queryKey,
    tectonicQuery.queryFn,
    {
      enabled: tectonicEnabled && (!type || type === 'TECTONIC'),
    },
  );

  const { data: stakedFerro, isLoading: ferroLoading } = useQuery(
    ferroQuery.queryKey,
    ferroQuery.queryFn,
    {
      enabled: !type || type === 'FERRO',
    },
  );

  const { data: stakedVvs, isLoading: vvsLoading } = useQuery(
    vvsQuery.queryKey,
    vvsQuery.queryFn,
    {
      enabled: !type || type === 'VVS',
    },
  );

  const { data: stakedVvsCro, isLoading: vvsCroLoading } = useQuery(
    vvsCroQuery.queryKey,
    vvsCroQuery.queryFn,
    {
      enabled: !type || type === 'VVS_CRO',
    },
  );

  return {
    stakedFerro,
    stakedTectonic,
    stakedVvs,
    vvsLoading,
    stakedVvsCro,
    vvsCroLoading,
    tectonicLoading,
    ferroLoading,
  };
};

export default useLpAmountsStaked;
